import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const Spacing = styled.span`
  padding: 0 5px;
  font-size: 14px;
  align-self: center;
  letter-spacing: 0.2px;
`;

export const InfoContainer = styled.div`
  align-self: center;
  display: flex;
  width: auto;
  color: ${({ theme }) => theme.white.a5};
  padding-top: 1rem;
  ${media.phone`
    display: none;
  `}
`;
